import { css, SerializedStyles } from '@emotion/core'

import { Color } from '../../../enums/color'
import { StyledComponent } from '../../../types/styledComponent'

export const getDangerStyle = (Control: StyledComponent, checked: boolean): SerializedStyles => css`
  ${Control} {
    ${checked
      ? css`
          background-color: ${Color.Red700};
        `
      : css`
          background-color: ${Color.Grey600};
        `};
  }
  &:hover {
    ${Control} {
      ${checked
        ? css`
            background-color: ${Color.Red700};
          `
        : css`
            background-color: ${Color.Grey600};
          `};
    }
  }
`
